import * as Scrivito from "scrivito";
import I18n from "^/config/i18n";

function OverviewPageInfo({ page, objClass }) {
  const getPageType = (panelClass) =>
    ({
      BlogPost: "Blog Post",
      NewsPage: "News",
      EventPage: "Event",
    }[panelClass]);
  return (
    <Scrivito.InPlaceEditingOff>
      <div className="mt-5">
        <Scrivito.ImageTag
          content={page}
          attribute="image"
          className="img-fluid"
          alt={page.get("image")?.get("alternativeText")}
          loading="lazy"
          width={page.get("image")?.metadata().get("width")}
          height={page.get("image")?.metadata().get("height")}
        />
        <div className="px-0 py-3">
          <Scrivito.ContentTag
            content={page}
            tag="h4"
            attribute="headline"
            className="text-left m-0 pb-0"
          />
          <ul className="vertical-list dots-list mx-0 my-2">
            {page.get("subHeadline").map((text, index) => (
              <li key={index}>{text}</li>
            ))}
          </ul>
          <Scrivito.ContentTag
            content={page}
            tag="div"
            attribute="description"
          />
          <Scrivito.LinkTag to={page} className="btn bg-blue">
            {I18n.t("BlogPost to", { pageType: getPageType(objClass) })}
          </Scrivito.LinkTag>
        </div>
      </div>
    </Scrivito.InPlaceEditingOff>
  );
}

export default Scrivito.connect(OverviewPageInfo);
